// Reload only after the new worker actually controls this page.
export function activateWaitingWorker(serviceWorker, waiting, reload, timedOut, timeout = 8000) {
  let finished = false;
  const cleanup = () => {
    serviceWorker.removeEventListener('controllerchange', changed);
    clearTimeout(timer);
  };
  const changed = () => {
    if (finished) return;
    finished = true;
    cleanup();
    reload();
  };
  const timer = setTimeout(() => {
    if (finished) return;
    finished = true;
    cleanup();
    timedOut();
  }, timeout);
  serviceWorker.addEventListener('controllerchange', changed);
  try { waiting.postMessage({ type: 'SKIP_WAITING' }); }
  catch { finished = true; cleanup(); timedOut(); }
  return () => { finished = true; cleanup(); };
}
